import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoayodhyacab() {



  const cardData =
  {
    keyword: 'Mumbai to Ayodhya Cab',
    heading: 'Shambhu Cabs: Mumbai to Ayodhya Cab',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Ayodhya Cab services, providing safe, comfortable, and hassle-free long-distance travel for pilgrims, families, groups, and corporate travelers visiting the sacred city of Ayodhya. Our fleet of well-maintained hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and peaceful journey with spacious seating and clean interiors. With flexible one-way and round-trip options, professional chauffeurs, doorstep pickup across South Mumbai, Thane, Andheri, Navi Mumbai, and 24/7 booking assistance, Shambhu Cabs makes your pilgrimage or long-distance travel convenient and stress-free. For comfort, safety, and a dependable Mumbai to Ayodhya travel experience, Shambhu Cabs is your trusted choice.',

    top: 'Top Places to Visit in Ayodhya with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Shri Ram Janmabhoomi Temple",
    "description": "Shri Ram Janmabhoomi Temple is the holiest site in Ayodhya, believed to be the birthplace of Lord Rama. The newly constructed grand temple features majestic sandstone architecture, intricate carvings, and a spiritually uplifting atmosphere. Thousands of devotees visit daily to witness the idol of Balak Ram in the sanctum. The temple complex includes prayer halls, gardens, Yagyashala, and a massive courtyard. The divine aura, chanting of mantras, and beautifully illuminated premises in the evening make it the most important pilgrimage destination in India."
  },
  {
    "title": "Hanuman Garhi",
    "description": "Hanuman Garhi is a famous hilltop temple dedicated to Lord Hanuman and holds great significance in Ayodhya. Visitors climb a series of steps to reach the temple, where a statue of Bal Hanuman rests in the lap of Mata Anjani. The temple provides panoramic views of the town and is especially crowded during festivals like Hanuman Jayanti and Diwali. Its spiritual energy, vibrant surroundings, and ancient architecture attract pilgrims and tourists throughout the year."
  },
  {
    "title": "Kanak Bhawan",
    "description": "Kanak Bhawan is a beautifully designed temple gifted to Goddess Sita by Queen Kaushalya after her marriage to Lord Rama. The temple houses elegant idols of Lord Rama and Sita adorned with golden ornaments. The inner sanctum is known for its peaceful as well as divine ambiance. The architecture is splendid, with intricate artwork, arches, and colorful paintings depicting Ramayana events. Devotees love the serene environment and melodious devotional songs continuously playing inside."
  },
  {
    "title": "Saryu River Ghat (Ram ki Paidi)",
    "description": "Ram ki Paidi is a series of beautifully constructed ghats along the sacred Saryu River. Pilgrims take holy dips believing it purifies mind and soul. The area becomes mesmerizing during sunrise and sunset, and the daily Ganga Aarti at the Saryu Ghat is a divine experience featuring lamps, mantras, and musical hymns. The riverfront is clean, peaceful, and ideal for meditation, boat rides, and religious rituals, making it one of Ayodhya’s most serene spiritual spots."
  },
  {
    "title": "Treta Ke Thakur Temple",
    "description": "Treta Ke Thakur Temple is believed to stand on the spot where Lord Rama performed the Ashwamedha Yajna after returning to Ayodhya. The temple houses ancient idols of Lord Rama, Sita, Lakshmana, Bharata, Shatrughna, and Hanuman carved from a single black stone. Open only on specific auspicious days, it attracts thousands of devotees. Its historical significance and peaceful environment make it a deeply revered heritage site."
  },
  {
    "title": "Nageshwarnath Temple",
    "description": "Nageshwarnath Temple, dedicated to Lord Shiva, is considered one of the oldest temples in Ayodhya. According to legend, it was built by Kush, son of Lord Rama. The temple is beautifully decorated during Shivratri and attracts pilgrims throughout the year. Its ancient structure, sacred ambiance, and spiritual rituals make it an important destination for both Shiva devotees and history lovers exploring Ayodhya."
  },
  {
    "title": "Guptar Ghat",
    "description": "Guptar Ghat, located along the Saryu River, is believed to be the place where Lord Rama took Jal Samadhi and departed from this world. The ghat features beautiful steps, temples, and peaceful surroundings ideal for meditation. Visitors can enjoy boat rides, evening aarti, and scenic views. The quiet charm, historical legends, and riverfront beauty make Guptar Ghat a must-visit spot for spiritual seekers."
  },
  {
    "title": "Mani Parvat",
    "description": "Mani Parvat is a small hill with a height of about 65 feet, believed to be a part of the mountain carried by Hanuman from the Himalayas to Lanka. The hill offers panoramic views of Ayodhya city and houses several shrines and a Buddhist stupa. Surrounded by greenery and calm vibes, it is ideal for photography, sightseeing, and exploring the mythological history of the region."
  },
  {
    "title": "Dashrath Mahal",
    "description": "Dashrath Mahal is the royal residence of King Dashrath, father of Lord Rama. Located in the heart of Ayodhya, this palace-like temple features colorful murals, intricate carvings, and a vibrant courtyard where devotional singing and celebrations take place daily. Statues of Lord Rama, Lakshmana, and Sita adorn the inner sanctum. The lively atmosphere, traditional architecture, and historical significance attract thousands of visitors."
  },
  {
    "title": "Ram Katha Park",
    "description": "Ram Katha Park is a beautiful open-air cultural park used for devotional events, Ramayana recitations, music programs, and spiritual gatherings. Lush gardens, walking paths, and an amphitheater create a peaceful environment ideal for relaxation and cultural experiences. During festivals and special occasions, the park lights up with performances celebrating the life of Lord Rama. It is a vibrant hub showcasing Ayodhya’s spiritual and cultural richness."
  },
  {
    "title": "Sita ki Rasoi",
    "description": "Sita ki Rasoi is a symbolic kitchen believed to be used by Goddess Sita after her marriage to Lord Rama. The site contains ancient utensils, deities, and a calm devotional setting. It reflects the traditional household culture of the Ramayana era, offering a unique cultural and historical insight. Pilgrims and tourists visit to witness the preserved artifacts and the spiritual atmosphere associated with Mata Sita."
  }
],



"services": [
  {
    "name": "Mumbai Ayodhya Taxi Service",
    "description": "Mumbai Ayodhya Taxi Service provides a long-distance, comfortable, and reliable travel experience for passengers heading to the holy city of Ayodhya. This service includes well-maintained AC cabs, trained chauffeurs, and complete route assistance for a smooth intercity journey. Ideal for families, pilgrims, and corporate travelers, it ensures safe travel through long stretches of highway. With flexible scheduling, transparent pricing, and round-the-clock support, this service guarantees a stress-free trip from Mumbai to Ayodhya with maximum comfort and convenience."
  },
  {
    "name": "Ayodhya from Mumbai Cab",
    "description": "Ayodhya from Mumbai Cab service offers point-to-point travel from any location in Mumbai directly to Ayodhya. Designed for those seeking hassle-free, door-to-door transportation, this service includes sanitized vehicles, professional drivers, and flexible travel options. Passengers enjoy long-route comfort, smooth highway navigation, and safe driving throughout the journey. Perfect for pilgrimage travellers visiting Ram Mandir or those needing reliable intercity mobility."
  },
  {
    "name": "One Way Cab Mumbai to Ayodhya",
    "description": "One Way Cab Mumbai to Ayodhya provides a cost-effective, single-side travel option for passengers who do not require a return trip. With comfortable sedans, spacious SUVs, and premium options available, this service ensures relaxed long-distance travel. Customers benefit from transparent fares, no hidden charges, and a dedicated chauffeur for the entire journey. Ideal for shifting, long-term stays, pilgrimage visits, and one-time travel needs."
  },
  {
    "name": "Mumbai Ayodhya Car Rental",
    "description": "Mumbai Ayodhya Car Rental offers a range of vehicles including sedans, SUVs, and premium cars suitable for long-distance intercity travel. This service is perfect for those looking for multi-day rentals, flexible routing, and extended pilgrimage travel plans. Drivers are trained for long routes and ensure safety, comfort, and on-time arrival. Ideal for family groups, tourist travellers, corporate trips, and custom itinerary-based journeys."
  },
  {
    "name": "Intercity Cab Mumbai Ayodhya",
    "description": "Intercity Cab Mumbai Ayodhya is designed for seamless long-distance travel with premium comfort and professional service quality. This cab service focuses on reliability, safety, and high travel efficiency, making it suitable for both personal and business travel needs. The service includes GPS-enabled cars, air-conditioned interiors, and expert drivers familiar with interstate routes, ensuring stress-free travel."
  },
  {
    "name": "Affordable Mumbai Ayodhya Taxi",
    "description": "Affordable Mumbai Ayodhya Taxi offers budget-friendly long-distance transportation without compromising on comfort or safety. With competitive fares, clean cars, and experienced drivers, this service is ideal for pilgrims, students, families, and solo travelers seeking economical intercity travel. Passengers enjoy transparent pricing, fuel-inclusive rates, and smooth coordination throughout the journey."
  },
  {
    "name": "Mumbai to Ram Mandir Cab",
    "description": "Mumbai to Ram Mandir Cab is specifically tailored for pilgrims traveling to the newly built Ram Mandir in Ayodhya. The service ensures doorstep pickup, comfortable travel, and safe highway driving until reaching the temple. With trained pilgrimage chauffeurs, flexible timings, and well-maintained AC vehicles, passengers experience a peaceful journey toward the holy destination."
  },
  {
    "name": "Long Distance Cab Mumbai Ayodhya",
    "description": "Long Distance Cab Mumbai Ayodhya offers specialized long-route travel with extra-comfort seating, smooth suspension vehicles, and long-distance trained chauffeurs. It is ideal for extended routes, overnight travel, family trips, and multi-stop itineraries. This service emphasizes safety, comfort, and endurance, ensuring passengers have a smooth journey throughout the long interstate route."
  },
  {
    "name": "SUV Cab Mumbai Ayodhya",
    "description": "SUV Cab Mumbai Ayodhya provides spacious, powerful, and comfortable SUVs like Innova, Crysta, and Ertiga for long-distance travel. These vehicles offer superior legroom, luggage capacity, and long-route suspension designed for extended highway journeys. Ideal for large families, corporate teams, and group pilgrims, this service ensures premium comfort and high-end travel performance."
  },
  {
    "name": "Sedan Cab Mumbai Ayodhya",
    "description": "Sedan Cab Mumbai Ayodhya offers comfortable and fuel-efficient sedans including Dzire and Etios for long-distance travel. Suitable for solo travellers, couples, and small families, this service ensures smooth travel at economical pricing. Passengers enjoy clean interiors, AC comfort, and trained drivers for a safe and dependable Mumbai-to-Ayodhya journey."
  },
  {
    "name": "Premium Cab to Ayodhya",
    "description": "Premium Cab to Ayodhya provides luxury sedans and high-end SUVs with superior comfort, premium interiors, and professionally trained chauffeurs. This service is perfect for VIP passengers, business executives, and travellers seeking a luxurious travel experience. With privacy, comfort, and high-class service standards, it ensures a smooth and elegant journey to Ayodhya."
  },
  {
    "name": "24x7 Ayodhya Cab Mumbai",
    "description": "24x7 Ayodhya Cab Mumbai ensures round-the-clock availability for long-distance travel between Mumbai and Ayodhya. Whether early-morning departures or late-night travel is required, this service provides safe, reliable, and immediate cab options. Equipped with on-demand booking, dedicated customer support, and trained drivers, passengers enjoy uninterrupted accessibility anytime."
  },
  {
    "name": "Mumbai to Ayodhya Pilgrimage Cab",
    "description": "Mumbai to Ayodhya Pilgrimage Cab is specially curated for devotees and spiritual groups visiting Ayodhya for darshan. This service offers courteous drivers, prayer-friendly stop options, flexible routing, and comfortable AC cars. Ideal for senior citizens, families, and temple groups, ensuring a peaceful and devotional travel experience."
  },
  {
    "name": "Fast Cab Mumbai Ayodhya",
    "description": "Fast Cab Mumbai Ayodhya provides quick dispatch, immediate booking confirmation, and prompt departure for travellers seeking urgent long-distance transportation. This service is ideal for last-minute plans, emergency travel, or time-sensitive journeys. With quick customer support and available vehicles, it ensures fast and hassle-free travel arrangements."
  },
  {
    "name": "Mumbai Ayodhya Darshan Taxi",
    "description": "Mumbai Ayodhya Darshan Taxi offers complete pilgrimage travel with temple visit planning, dedicated chauffeur support, and customized sightseeing routes in Ayodhya. Pilgrims can comfortably visit Ram Mandir, Hanuman Garhi, Kanak Bhawan, and other sacred places. Perfect for families, groups, and spiritual travellers looking for guided temple travel."
  },
  {
    "name": "Corporate Cab Mumbai Ayodhya",
    "description": "Corporate Cab Mumbai Ayodhya is designed for business travellers needing reliable, premium, and comfortable long-distance travel solutions. Features include corporate billing, professional chauffeurs, high-comfort cars, and punctual travel schedules. Perfect for company executives, interstate official visits, and business meetings in Ayodhya or nearby areas."
  },
  {
    "name": "Safe Cab Mumbai Ayodhya",
    "description": "Safe Cab Mumbai Ayodhya ensures secure travel with verified drivers, GPS-enabled cars, sanitization protocols, and highway safety standards. Ideal for solo travellers, women passengers, families, and senior citizens, this service prioritizes comfort and security over long travel durations. It offers peace of mind with reliable safety measures throughout the interstate journey."
  }
],

"tableData": [
  ["Mumbai Ayodhya Taxi Service", "Ayodhya from Mumbai Cab"],
  ["One Way Cab Mumbai to Ayodhya", "Mumbai Ayodhya Car Rental"],
  ["Intercity Cab Mumbai Ayodhya", "Affordable Mumbai Ayodhya Taxi"],
  ["Mumbai to Ram Mandir Cab", "Long Distance Cab Mumbai Ayodhya"],
  ["SUV Cab Mumbai Ayodhya", "Sedan Cab Mumbai Ayodhya"],
  ["Premium Cab to Ayodhya", "24x7 Ayodhya Cab Mumbai"],
  ["Mumbai to Ayodhya Pilgrimage Cab", "Fast Cab Mumbai Ayodhya"],
  ["Mumbai Ayodhya Darshan Taxi", "Corporate Cab Mumbai Ayodhya"],
  ["Safe Cab Mumbai Ayodhya", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Ayodhya Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable Mumbai to Ayodhya cab services, perfect for pilgrimage trips, family journeys, and long-distance travel with complete comfort and safety."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced cabs designed to provide a smooth and comfortable ride on the long route from Mumbai to Ayodhya."
  },
  {
    "WhyChooseheading": "Experienced Long-Route Drivers",
    "WhyChoosedescription": "Our expert drivers are experienced in long-distance and interstate routes, ensuring safe driving, timely travel, and a hassle-free Mumbai to Ayodhya journey."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "We ensure clear and upfront pricing with no hidden charges—fuel, tolls, and driver allowances included for your Mumbai to Ayodhya cab booking."
  },
  {
    "WhyChooseheading": "24/7 Travel Assistance",
    "WhyChoosedescription": "Our customer support team is available 24/7 to assist with bookings, travel updates, route planning, and any trip-related queries."
  },
  {
    "WhyChooseheading": "Flexible Travel Options",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized travel plans crafted to suit your Mumbai to Ayodhya travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe, hygienic, and comfortable travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making your long-distance journey from Mumbai to Ayodhya smooth and worry-free."
  }
]
























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide cab service from Mumbai to Ayodhya?',
    answer: 'Yes, Shambhu Cabs offers reliable and comfortable cab services from Mumbai to Ayodhya for your spiritual and pilgrimage trips.',
  },
  {
    question: 'How can I book a cab from Mumbai to Ayodhya?',
    answer: 'You can easily book a cab from Mumbai to Ayodhya through our website, mobile app, or by contacting our 24x7 customer support team for a smooth booking experience.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Ayodhya cab bookings?',
    answer: 'Shambhu Cabs provides a range of vehicles for Mumbai to Ayodhya travel, including sedans, SUVs, luxury cars, and Tempo Travellers for family and group trips.',
  },
  {
    question: 'Are the drivers experienced for the Mumbai to Ayodhya journey?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with long-distance routes to ensure a safe and comfortable journey from Mumbai to Ayodhya.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for the Mumbai to Ayodhya trip?',
    answer: 'Yes, you can choose your preferred pickup and drop-off points within Mumbai and Ayodhya for a personalized travel experience.',
  },
  {
    question: 'Is the Mumbai to Ayodhya cab service available 24x7?',
    answer: 'Yes, Shambhu Cabs provides round-the-clock service for your Mumbai to Ayodhya journey, so you can travel at your convenience.',
  },
  {
    question: 'Are safety and hygiene protocols followed for the Mumbai to Ayodhya trip?',
    answer: 'Yes, all our vehicles are sanitized regularly, and our drivers follow strict hygiene and safety measures to ensure your well-being throughout the journey.',
  },
  {
    question: 'What payment options are available for Mumbai to Ayodhya cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate payments for Mumbai to Ayodhya cab bookings.',
  },
  {
    question: 'Is customer support available during my Mumbai to Ayodhya trip?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your journey from Mumbai to Ayodhya.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vinod Kumar',
    feedback: 'Our journey from Mumbai to Ayodhya with Shambhu Cabs was fantastic. The driver was very professional, and the vehicle was comfortable for the long trip.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rina Patel',
    feedback: 'Shambhu Cabs made our pilgrimage to Ayodhya smooth and hassle-free. Excellent service and timely arrival made the trip memorable.',
    rating: 5,
  },
];








































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Mumbai to Ayodhya Cab",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-ayodhya-cab.jpg",
  "description": "Shambhu Cabs provides reliable Mumbai to Ayodhya cab services. Book affordable, premium, SUV, and sedan cabs for one-way, pilgrimage, or corporate travel, available 24×7.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-ayodhya-cab"
  }
};




  return (
    <div>
<Helmet>
  <title>Mumbai to Ayodhya Cab | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Ayodhya cab services with Shambhu Cabs. Reliable, affordable, and premium cabs for one-way, pilgrimage, or corporate travel, available 24×7."
  />

  <meta
    name="keywords"
    content="Mumbai Ayodhya Taxi Service, Ayodhya from Mumbai Cab, One Way Cab Mumbai to Ayodhya, Mumbai Ayodhya Car Rental, Intercity Cab Mumbai Ayodhya, Affordable Mumbai Ayodhya Taxi, Mumbai to Ram Mandir Cab, Long Distance Cab Mumbai Ayodhya, SUV Cab Mumbai Ayodhya, Sedan Cab Mumbai Ayodhya, Premium Cab to Ayodhya, 24x7 Ayodhya Cab Mumbai, Mumbai to Ayodhya Pilgrimage Cab, Fast Cab Mumbai Ayodhya, Mumbai Ayodhya Darshan Taxi, Corporate Cab Mumbai Ayodhya, Safe Cab Mumbai Ayodhya"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/58.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoayodhyacab;